export const handleStarRating = (starRating) => {
  const decimalRating = starRating - Math.floor(starRating);
  if (decimalRating > 0 && decimalRating < 0.4) {
    starRating = starRating + 0.05;
  } else if (decimalRating > 0.6 && decimalRating < 1) {
    starRating = starRating - 0.05;
  }
  return starRating.toFixed(2);
}